import React from 'react'
import '../commanComponents.css'

export default function  GreenButton({ onClick, style, icon, text, isOutLined, className }) {
  return (
    <button className={`${isOutLined? "greenBtnOutlined" : "greenBtn"} ${className}` } onClick={onClick} style={style}>
      <div>{icon}</div>
      {text}
    </button>
  )
}
